import { getSiteOrigin } from './siteMeta';

export function buildSharePreviewUrl(contentType, slug) {
  if (!contentType || !slug) {
    return null;
  }

  const normalizedType = String(contentType).trim().toLowerCase();
  if (!['post', 'tech', 'episode', 'product'].includes(normalizedType)) {
    return null;
  }

  return `${getSiteOrigin()}/share/${normalizedType}/${slug}`;
}

export function resolveShareUrl(item, fallbackUrl = '') {
  if (item?.share_url) {
    return item.share_url;
  }

  if (item?.share_type && item?.slug) {
    return buildSharePreviewUrl(item.share_type, item.slug) || fallbackUrl;
  }

  return fallbackUrl;
}
